import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
} from '@angular/common/http';
import { isPlatformServer } from '@angular/common';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { LanguageHandlerService } from '../services/language-handler.service';
import { ServerCache } from '../models/server-state.model';

@Injectable()
export class BrowserStateInterceptor implements HttpInterceptor {
  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private transferState: TransferState,
    private langHandlerService: LanguageHandlerService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.method !== 'GET' || isPlatformServer(this.platformId)) {
      return next.handle(req);
    }

    const stateKey = makeStateKey<ServerCache>(req.url);
    const { lang, response } = this.transferState.get(stateKey, {
      lang: this.langHandlerService.currentLang,
      response: null,
    });

    // Language is incorrect when API request is lang. dependent & it's lang is not equal to the cached response
    const isLangIncorrect =
      lang !== this.langHandlerService.currentLang && lang !== 'all';

    if (isLangIncorrect || !response) {
      return next.handle(req);
    }

    this.transferState.remove(stateKey);

    return of(
      new HttpResponse({
        body: response,
      })
    );
  }
}
